import React, { Component } from 'react'
import moment from "moment-timezone";
import "./Message.css";
import Api from "../../customlib/Api";
import { FaFile } from "react-icons/fa";
import ImageZoom from 'react-medium-image-zoom';
import {LocationOn, Done, DoneAll, Replay, Error, ReportOff, QueryBuilder, Assignment, Help, MoreHoriz, MoreVert, Info, Visibility, Face, MarkChatRead, PersonPin, Person} from "@mui/icons-material";
import {Avatar, Box, Button, Divider, List, ListItem, ListItemAvatar, ListItemText, Menu, MenuItem, Tooltip as ToolTip, Tooltip, Typography}  from "@mui/material";
import ReactPlayer from "react-player";
import Global from "../../customlib/Global";
import OpenStreetMap from '../MapPreview/OpenstreetMap';
// import {AdvancedMarker, APIProvider, Map} from '@vis.gl/react-google-maps';
// import MapPreview from '../MapPreview';
// import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
// import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L, { icon } from 'leaflet';
import axios from 'axios';

// Make sure to import the Leaflet CSS
import 'leaflet/dist/leaflet.css';
import MyAudioPlayer from '../../customlib/MyAudioPlayer';
// import OpenStreetMap from '../MapPreview/OpenstreetMap';

class Message extends Component {
    state = { 
        isMenuOpen: false,
        anchorEl: null,
        position: {lat: 53.54992, lng: 10.00678},
        map: null, 
        isMapRendered: false,
        showRevisionLog: false,
        revisoinLogs: ""
    }

    handleClick = (event) => {
        console.log(event);
        this.setState({anchorEl: event.target, isMenuOpen: true});
    };
    handleClose = (messageText) => {
        this.setState({anchorEl: null, isMenuOpen: false});
        // this.props.onOpenCreateOrder(messageText);
    };

    handleOpenCreateOrder = () => {
        // this.handleClose();
        this.props.onOpenCreateOrder();
    }

    componentDidMount() {
        try {

            if(this.props.data.message.type === "LOCATION" && this.state.isMapRendered === false){

                let location = this.props.data.message.location;

                let map = L.map(`map${this.props.data.message.id}`).setView([location.lat,location.long], 15);
                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }).addTo(map);
                const customIcon = new L.Icon({
                    iconUrl: '/location-pin.png', // Correct path
                    iconSize: [24, 24], // Adjust size
                    iconAnchor: [16, 32], // Anchor point of the icon (adjust accordingly)
                    popupAnchor: [0, -32], // Position of popup relative to the icon
                  });
                let marker = L.marker([location.lat,location.long], {icon: customIcon}).addTo(map);
                this.setState({isMapRendered: true});
            }

        } catch (error) {
            console.log("PRINTIT", error);
        }
        // console.log("MESSAGE_DATA",this.props.data);
    }
    

    formatText = () => {
        if(this.props.data.message.type === "TEXT"){
            return this.props.data.message.text !== undefined ? this.replaceNewLine(this.props.data.message.text) : "";
        }else{
            return this.props.data.message.caption !== undefined ? this.replaceNewLine(this.props.data.message.caption) : "";
        }
    }

    formatReplyMessage = (replyData) => {
        if(replyData.message !== undefined){
            if(replyData.message.type === "TEXT"){
                return (
                    <div style={{backgroundColor: '#64b5f6', borderRadius: 10, paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, color: "#000000", borderLeft: 'solid', borderLeftWidth: 5, borderLeftColor: "#ff7043", fontSize: 11}}>
                        {replyData.message.text}
                    </div>
                );
            }else if(replyData.message.type === "IMAGE"){
                return (
                <div style={{backgroundColor: '#64b5f6', borderRadius: 10, paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, color: "#000000", borderLeft: 'solid', borderLeftWidth: 5, borderLeftColor: "#ff7043", fontSize: 11}}>
                    {replyData.message.caption}<br />
                    <ImageZoom
                        image={{
                        src: Api.getBaseImageUrl() + replyData.message.fileName,
                        alt: 'Golden Gate Bridge',
                        className: 'img-fluid img-thumbnail mx-auto d-block media-size'
                        }}
                        zoomImage={{
                        src: Api.getBaseImageUrl() + replyData.message.fileName,
                        alt: 'Golden Gate Bridge'
                        }}
                    />
                    <div className="btn btn-primary btn-sm btn-block" style={{marginBottom: "5px"}} onClick={() => this.downloadFile(Api.getBaseImageUrl() + replyData.message.fileName)}>
                        Download
                    </div>
                </div>
                );
            }else if(replyData.message.type === "DOCUMENT"){
                return (
                <div style={{backgroundColor: '#64b5f6', borderRadius: 10, paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, color: "#000000", borderLeft: 'solid', borderLeftWidth: 5, borderLeftColor: "#ff7043", fontSize: 11}}>
                    {replyData.message.caption}<br />
                    <div className="btn btn-warning" onClick={() => this.props.onDownloadDocument(replyData.message.fileName)}>
                        <FaFile /> Buka dokumen
                    </div>
                    <div className="btn btn-primary btn-sm btn-block" style={{marginBottom: "5px"}} onClick={() => this.downloadFile(Api.getBaseDocsUrl() + replyData.message.fileName)}>
                        Download
                    </div>
                </div>
                );
            }
        }else{
            return (<div className="bg-info" style={{borderRadius: 10, padding: 5}}>Reply data missing</div>);
        }
        
    } 

    replaceNewLine = (text) => {
        var splitted = text.split("\n");

        if(splitted.length <= 1){
            return text;
        }

        var joined = splitted.map(str => <Box>{str}</Box>);
        return joined;
    } 

    downloadFile = (url) => {
        const fileName = url.split("/").pop();
        const aTag = document.createElement("a");
        aTag.href = url;
        aTag.setAttribute("download", fileName);
        aTag.setAttribute("target", "_blank");
        document.body.appendChild(aTag);
        aTag.click();
        aTag.remove();
    }

    handleOpenMap = (latitude, longitude) => {
        var url = `https://maps.google.com/maps?ll=${latitude},${longitude}&z=18&q=${latitude},${longitude}`;
        // var url = `https://maps.google.com/maps?ll=-7.508655,110.813931&z=18&q=`;
        //https://lavender.prestisa.id/#!/enquiries/create/eyJwaG9uZSI6IjYyODEzOTg3NDk3NTkifQ==
        var win = window.open(url, '_blank');
        win.focus();
    
    }

    toggleShowRevisionLog = () => {
        this.setState({showRevisionLog: !this.state.showRevisionLog});
    }

    RevisionComponent = () => {
        // return <Button variant='text'>Lihat Catatan Revisi {this.props.data.message.text}</Button>;
        if(this.props.data.message.text === "Revisi" && !this.state.showRevisionLog){
            return <Box>
                <Button variant='outlined' size='small' onClick={this.loadRevisionNotes}>Lihat Catatan Revisi</Button>
            </Box>;
        }

        if(this.props.data.message.text === "Revisi" && this.state.showRevisionLog === true){
            return <Box sx={{ml: "15px", fontSize: "10px"}}>
                <Box><strong>Catatan Revisi</strong></Box>
                <Divider sx={{mt: "5px", mb: "10px"}} />
                <Box>{this.state.revisoinLogs}</Box>
            </Box>;
        }

    }

    loadRevisionNotes = () => {
        const params = {
        };

        let text = this.props.data.repliedMessage.message.caption;
        text = text.replace("Foto hasil untuk PO ", "");
        axios
          .get(
            Api.getPoInfoById(text),
            Api.getRequestHeader()
          )
          .then((response) => {
            console.log("App Profiles", response.data);
            if(response.data && response.data.success){
                this.setState({revisoinLogs: response.data.data.revision_image_log});
                this.toggleShowRevisionLog();
            }
            
          })
          .catch((error) => {
            
            // this.setState({ errorMessage: error.message, loginSuccess: false });
            console.error("There was an error!", error);
            // this.props.onLogin();
          }
        );
    };

    render() { 

        const { data, isMine, startsSequence, endsSequence, showTimestamp} = this.props;
        const friendlyTimestamp = Global.formatDateTimeToStrFormat(data.created_at, "LLLL");
        const timeOnly = Global.formatDateTimeToStrTime24(data.created_at, true);
        const messageWidgetClasses = data.message.type === "TEXT" ? "d-none" : "";
        const messageText = data.message.type === "TEXT" ? data.message.text : data.message.caption;
        // const isFormPemesanan = messageText.includes("Untuk pemesanan, silahkan lengkapi form data berikut");
        const isFormPemesanan = messageText?.toLowerCase()?.includes(Global.FORM_ORDER_MESSAGE_MARK.toLowerCase()) && !isMine;
        const isImageMessage = data.message.type === "IMAGE" | data.message.type === "STICKER";
        const isDocumentMessage = data.message.type === "DOCUMENT";
        const isLocationMessage = data.message.type === "LOCATION";
        const isAudioMessage = data.message.type === "AUDIO";
        const audioUrl = isAudioMessage ? data.message.fileName : "";

        let minLong = 0;
        let minLat = 0;
        let maxLong = 0;
        let maxLat = 0;
        const boundaryRange = 0.009; // 1 KM
       
        if(isLocationMessage){
            minLong = data.message.location?.long - boundaryRange;
            minLat = data.message.location?.lat - boundaryRange;
            maxLong = data.message.location?.long + boundaryRange;
            maxLat = data.message.location?.lat + boundaryRange;

            // try {

            //     if(this.props.data.message.type === "LOCATION" && this.state.isMapRendered === false){
    
            //         let location = this.props.data.message.location;
    
            //         var map = L.map(`map${data.message.id}`).setView([location.lat,location.long], 15);
            //         L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //             maxZoom: 19,
            //             attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            //         }).addTo(map);
            //         const customIcon = new L.Icon({
            //             iconUrl: '/location-pin.png', // Correct path
            //             iconSize: [24, 24], // Adjust size
            //             iconAnchor: [16, 32], // Anchor point of the icon (adjust accordingly)
            //             popupAnchor: [0, -32], // Position of popup relative to the icon
            //           });
            //         var marker = L.marker([location.lat,location.long], {icon: customIcon}).addTo(map);
            //         this.setState({isMapRendered: true});
            //     }
    
            // } catch (error) {
            //     console.log("PRINTIT", error);
            // }
        }
        // const isFormPemesanan = false;

        return ( 
            <div
            className={[
                "message",
                `${isMine ? "mine" : ""}`,
                `${startsSequence ? "start" : ""}`,
                `${endsSequence ? "end" : ""}`,
            ].join(" ")}
            >
            {showTimestamp && <div className="timestamp">{friendlyTimestamp}</div>}

            <div className="bubble-container">
                
                <div className="bubble" 
                    // title={friendlyTimestamp}
                >
                    {/* {data.message.type !== "TEXT" ? data.message.caption.replace("\n", "<br />") ? data.message.caption.replace("\n", "<br />") : "" : data.message.text.replace("\n", "<br />")} */}
                    {
                        data.repliedMessage !== undefined && data.repliedMessage !== null ? 
                        this.formatReplyMessage(data.repliedMessage) : 
                        // (<div>{data.messageId}</div>)
                        (<></>)
                    }
                    {this.formatText()}

                    <div className={messageWidgetClasses}>
                    {/* <APIProvider apiKey={'AIzaSyBys4EI0yuZd9hC7umhIys-_fAT6Yw7f4g'}>
                        <Map defaultCenter={this.state.position} defaultZoom={10} mapId="DEMO_MAP_ID">
                            <AdvancedMarker position={this.state.position} />
                        </Map>
                    </APIProvider> */}

                    {/* <MapPreview /> */}

                    {
                        isImageMessage ? 
                        // (<img className="img-fluid img-thumbnail mx-auto d-block media-size" src={Api.getBaseImageUrl() + data.message.fileName} alt=""/>) : 
                        (
                            <ImageZoom
                                image={{
                                src: data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseImageUrl() + data.message.fileName,
                                alt: '',
                                className: 'img-fluid img-thumbnail mx-auto d-block media-size'
                                }}
                                zoomImage={{
                                src: data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseImageUrl() + data.message.fileName,
                                alt: ''
                                }}
                            />
                            // <></>
                        ) : (<></>)
                    }    
                    {
                        isImageMessage ? (
                            <div className="btn btn-primary btn-sm btn-block" style={{marginBottom: "5px"}} onClick={() => this.downloadFile((data.message.fileName.startsWith("http") ? "" : Api.getBaseImageUrl()) + data.message.fileName)}>
                                Download
                            </div>
                        ) : (<></>)
                    }

                    {
                        data.message.type === "LOCATION" && (
                            // <OpenStreetMap />
                            // <div style={{ height: '200px', width: '300px' }}>
                            //     <MapContainer center={[data.message.location?.lat,data.message.location?.long]} zoom={15} style={{ height: '100%', width: '100%' }}>
                            //         <TileLayer
                            //             url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            //             attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            //         />
                            //         <Marker position={[data.message.location?.lat,data.message.location?.long]}>
                            //         <Popup>
                            //             This is your location!
                            //         </Popup>
                            //         </Marker>
                            //     </MapContainer>
                            // </div>

                            <Box sx={{cursor: "pointer"}} onClick={() => {this.handleOpenMap(data.message.location?.lat, data.message.location?.long)}}>
                                {/* <Box
                                 id={`map${data.message.id}`} 
                                 sx={{height: "100px", width: "100%", marginTop: "5px", borderRadius: "10px 10px 5px 5px"}}
                                >
                                </Box> */}
                                <iframe 
                                    title={data.messageId}
                                    width="100%" 
                                    height="150" 
                                    frameborder="0" 
                                    scrolling="no" 
                                    marginheight="0" 
                                    marginwidth="0" 
                                    // src={`https://maps.google.com/maps?width=100%25&amp;height=200&amp;hl=en&amp;q=${data.message.location?.lat},${data.message.location?.long}&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`}>
                                    // src={`https://www.openstreetmap.org/#map=19/-7.510531/110.813985`}>
                                    src={`https://www.openstreetmap.org/export/embed.html?bbox=${minLong},${minLat},${maxLong},${maxLat}&layer=mapnik`}>
                                    
                                </iframe>
                                {/* <iframe
                                    title={data.messageId}
                                    width="100%"
                                    height="150"
                                    frameBorder="0"
                                    loading="lazy"
                                    allowfullscreen
                                    referrerpolicy="no-referrer-when-downgrade"
                                    src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBys4EI0yuZd9hC7umhIys-_fAT6Yw7f4g&q=${data.message.location?.lat},${data.message.location?.long}`}>
                                </iframe> */}
                                <Box sx={{fontWeight: "bold", color: '#007BFF', marginTop: "10px"}}>
                                    <LocationOn sx={{fontSize: "17px", color: "#DC3545"}} />
                                    {data.message.location?.name}
                                </Box>
                                <Box sx={{marginTop: "5px"}}>{data.message.location?.address}</Box>
                                <Box sx={{fontSize: "11px"}}>{data.message.location?.lat}, {data.message.location?.long}</Box>
                                {/* <Box sx={{fontSize: "11px"}}>{`https://www.openstreetmap.org/export/embed.html?bbox=${minLong},${minLat},${maxLong},${maxLat}&layer=mapnik`}</Box> */}

                            </Box>
                        )
                    }

                    {
                        data.message.type === "DOCUMENT" ? (
                            <>
                                <br />
                                <div className="btn btn-warning" onClick={() => this.props.onDownloadDocument(data.message.fileName)}>
                                    <FaFile /> Buka dokumen
                                </div>
                                &nbsp;
                                
                                {
                                    data.status === "FAILED" ? 
                                    (
                                        <div className="btn btn-danger" onClick={() => this.props.onResendMessage(data)}>
                                            <Replay />
                                        </div>
                                    ) : (<></>)
                                }
                                
                                
                            </>

                        ) : (<></>)
                    }
                    {
                        data.message.type === "CONTACTS" ? (
                            <>
                                <br />
                                <Box>
                                    <List dense sx={{ marginTop: 0, width: '100%', maxWidth: 360, bgcolor: 'background.paper',paddingLeft: "5px", paddingRight: "5px", paddingTop: 0, paddingBottom: 0, borderRadius: "10px" }}>
                                        {
                                            data.message.contacts?.map(item => (
                                                <ListItem alignItems="flex-start" sx={{padding: 0}}>
                                                    <ListItemAvatar>
                                                        <Avatar sizes='small' alt={item.name.formatted_name} src="/static/images/avatar/1.jpg" />
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={item.name.formatted_name}
                                                        // primary={JSON.stringify(item)}
                                                        secondary={
                                                        <React.Fragment>
                                                            {
                                                                item.phones?.map(phone => (
                                                                    <Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        sx={{ color: 'text.secondary', display: 'inline', fontSize: "11px" }}
                                                                    >
                                                                        {phone?.phone?.replaceAll("+", "").replaceAll("-", "").replaceAll(" ", "")}
                                                                    </Typography>
                                                                ))
                                                            }
                                                        </React.Fragment>
                                                    }
                                                    />
                                                </ListItem>
                                            ))
                                        }
                                    </List>
                                </Box>
                            </>

                        ) : (<></>)
                    }
                    {
                        data.message.type === "DOCUMENT" ? (
                            <div className="btn btn-primary btn-sm btn-block" style={{marginBottom: "5px"}} onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>
                                Download
                            </div>
                        ) : (<></>)
                    }

                    {
                        data.message.type === "VIDEO" ? (<ReactPlayer width="100%" style={{maxHeight: "250px"}} controls={true} url={data.message.fileName !== undefined && data.message.fileName.startsWith("http") ? data.message.fileName : Api.getBaseVideosUrl() + data.message.fileName} />) : (<></>)
                    }

                    {
                        (isAudioMessage && data.message.fileName.length > 0) && <MyAudioPlayer currentSong={Api.getBaseAudiosUrl() + data.message.fileName} />
                    }

                    </div> 
                    {
                        <this.RevisionComponent />
                    }
                    <div className='text-right'>
                        {
                        data.markedAsRead && data.markedAsReadAt && 
                            <ToolTip title={"Dibaca oleh " + data.markedAsReadByName + " pada " + Global.formatDateTimeToStrDateTime24(data.markedAsReadAt)}>
                                <Face color='secondary' fontSize='15' style={{cursor: "pointer"}} />
                            </ToolTip>}
                        &nbsp;
                        <span className="text-right" style={{fontSize: 9}}>
                            
                            {isMine ? Global.maskPhoneNumber(data.to) : data.to} - {timeOnly}
                            {/* {!isMine ? data.messageId : ""} */}
                            {/* {data.message.type}{isImageMessage} */}
                        </span>
                    </div>
                    
                </div>
                
                {/* {
                    isFormPemesanan && <MoreHoriz />
                } */}

                <div className="indicator">
                {
                        data.status === "SEEN" && isMine ? 
                        (
                            <ToolTip title="Sudah dibaca">
                                <DoneAll style={{color: "#00c853", width: 18}} />
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "DELIVERED_TO_HANDSET" && isMine ? 
                        (
                            <ToolTip title="Sudah sampai ke handset pelanggan">
                                <DoneAll style={{width: 18}}/>
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "DELIVERED_TO_OPERATOR" && isMine ? 
                        (
                            <ToolTip title="Sudah dikirim ke server WA">
                                <Done style={{width: 18}}/>
                            </ToolTip>
                        ) : 
                        (<></>)
                    }
                    
                    {
                        data.status === "UNDELIVERABLE_NOT_DELIVERED" && isMine ? 
                        (
                            <ToolTip title={(<>Pesan tidak dapat dikirim ke pelanggan<br />Coba kirim pesan HSM terlebih dahulu</>)}>
                                <Error style={{color: "#FF0000", width: 18}} />
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "FAILED" && isMine ? 
                        (
                            <ToolTip title="Pesan gagal dikirim">
                                <Error style={{color: "#FF0000", width: 18}} />
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "FAILED_PERMANENTLY" && isMine ? 
                        (
                            <ToolTip title="Pesan gagal dikirim">
                                <ReportOff style={{color: "#FF0000", width: 18}} />
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "SENDING" && isMine ? 
                        (
                            <ToolTip title="Pesan sedang dikirim">
                                <QueryBuilder style={{width: 18}}/>
                            </ToolTip>
                        ) : 
                        (<></>)
                    }

                    {
                        data.isTemplate !== undefined && data.isTemplate === 1 && isMine ? 
                        (
                            <div>
                                <ToolTip title={`Pesan template - ${data.hsmName}`}>
                                    <Assignment style={{width: 18, color: "#0000FF"}}/>
                                </ToolTip>
                            </div>
                            
                        ) : 
                        (<></>)
                    }

                    {
                        data.status === "NOSTATUS" && isMine ? 
                        (
                            <ToolTip title="Jenis pesan tidak diketahui">
                                <Help style={{width: 18, color: "#FF0000"}}/>
                            </ToolTip>
                        ) : 
                        (<></>)
                    }
                </div>
                    {
                        // (!isMine && this.props.onOpenCreateOrder && this.props.onOpenCustomerProfile) &&  
                        (!isMine && this.props.onOpenCreateOrder) &&  
                        // (!isMine && (isFormPemesanan || isImageMessage)) && 
                        // <Tooltip title="Pilih opsi">
                            <span>
                                
                                    <div onClick={this.handleClick} className="btn btn-sm btn-text p-0" style={{marginLeft: "0px", padding: "0px", borderRadius: "200px"}}>
                                        <MoreVert className='text-danger' />
                                    </div>
                                    <Menu
                                        id={"menu-" + data._id}
                                        anchorEl={this.state.anchorEl}
                                        open={this.state.isMenuOpen}
                                        onClose={this.handleClose}
                                        MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                        }}
                                    >
                                        {/* {(isFormPemesanan && (Global.get().admin || Global.isSales())) && 
                                            <MenuItem onClick={this.props.onOpenCreateOrder(messageText)}>Create Order</MenuItem>
                                        }
                                        {isImageMessage === true ? <MenuItem onClick={() => this.downloadFile(Api.getBaseImageUrl() + data.message.fileName)}>Download Image</MenuItem> : <></>}
                                        {isDocumentMessage === true ? <MenuItem onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>Download Document</MenuItem> : <></>}
                                        {isDocumentMessage === true ? <MenuItem onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>Download Document</MenuItem> : <></>} */}
                                        
                                        <MenuItem disabled={!(isFormPemesanan && (Global.get().admin || Global.isSales()))} onClick={this.props.onOpenCreateOrder(messageText)}>Create Order</MenuItem>
                                        {/* <MenuItem onClick={this.props.onOpenCustomerProfile(messageText)}>Customer Profile</MenuItem> */}
                                        <MenuItem disabled={!isImageMessage} onClick={() => this.downloadFile((data.message.fileName.startsWith("http") ? "" : Api.getBaseImageUrl()) + data.message.fileName)}>Download Image</MenuItem>
                                        <MenuItem disabled={!isDocumentMessage} onClick={() => this.downloadFile(Api.getBaseDocsUrl() + data.message.fileName)}>Download Document</MenuItem>
                                        {/* <MenuItem onClick={() => this.handleClose(messageText)}>Create Order</MenuItem> */}
                                    </Menu>
                            </span>
                        // </Tooltip>
                    }
                </div>
            </div>
         );
    }
}
 
export default Message;

// export default function Message(props) {
  

//   return (
//     <div
//       className={[
//         "message",
//         `${isMine ? "mine" : ""}`,
//         `${startsSequence ? "start" : ""}`,
//         `${endsSequence ? "end" : ""}`,
//       ].join(" ")}
//     >
//       {showTimestamp && <div className="timestamp">{friendlyTimestamp}</div>}

//       <div className="bubble-container">
//         <div className="bubble" title={friendlyTimestamp}>
//             {data.message.type !== "TEXT" ? data.message.caption.replace("\n", "<br />") ? data.message.caption.replace("\n", "<br />") : "" : data.message.text.replace("\n", "<br />")}
//             <div className={messageWidgetClasses}>
//             {
//                 data.message.type === "IMAGE" ? 
//                 (<img className="img-fluid img-thumbnail mx-auto d-block media-size" src={Api.getBaseImageUrl() + data.message.fileName} alt=""/>) : 
//                 (
//                     <>
//                         <br />
//                         <div className="btn btn-warning" onClick={() => props.onDownloadDocument(data.message.fileName)}>
//                             <FaFile /> Download dokumen
//                         </div>
//                     </>

//                 )
//             }
//             </div>
//         </div>
//       </div>
//     </div>
//   );
// }
